<script lang="ts">
import { useStateManager } from '@/store'
import { defineComponent } from 'vue'
import { useRoute } from 'vue-router'

/**
 * This redirect component is mainly used for local oauth sso test system. In real life, the request is redirected via
 * nginx (or traefik)
 */
export default defineComponent({
  name: 'OauthLoginRedirect',
  setup() {
    useStateManager().reset()

    // Redirect to https://www.itscope.com/oauth2/*
    const url = window.STOREFRONT_API_BASE_URL

    const pathArray = url.split('/')
    const protocol = pathArray[0]
    const host = pathArray[2]
    const baseUrl = protocol + '//' + host

    const target = baseUrl + useRoute().path
    window.open(target, '_self')
  }
})
</script>
